export class UserLogin {
  constructor(userName?: string, password?: string, rememberMe?: boolean, email?: string) {
    this.userName = userName;
    this.password = password;
    this.rememberMe = rememberMe;
    this.email = email;
  }

  userName: string;
  password: string;
  rememberMe: boolean;
  email: string;
}
